export const TESTER_PRICE = {
  PRICE: 5,
};

export const CONTOUR_PRICE = 50;
export const COLOR_PRICE = 34;
export const HIGHEST_COMPLEXITY_LEVEL = 4;
export const MIN_MESSAGE_LENGTH_OF_RETURN_WORk = 4;
export const SPECIAL_TAGS = [ 'mystery', 'colorlines', 'nolines' ];
